
let baseURL: string;

if (process.env.NODE_ENV === 'development') {
    baseURL = 'https://api.hine.studio/api';
} else {
    baseURL = 'https://hine.up.railway.app/api';
}
console.log(process.env.NODE_ENV )
export const base = baseURL;